<template>
  <div>
    <span
      :class="state.color"
      class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none  rounded"
    >
      {{state.nome}}
    </span>

  </div>
</template>

<script>
export default {
  props: ['state']
}
</script>

<style>
</style>
